import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Chip,
  Box,
  Grid,
  Paper,
  Avatar,
  Tooltip,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import AssignmentIcon from '@material-ui/icons/Assignment';
import PendingIcon from '@material-ui/icons/Schedule';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import FilterListIcon from '@material-ui/icons/FilterList';
import TituloAccion from '../general/TituloAccion';
import AccionesRapidas from '../general/AccionesRapidas';
import TareasTerminadas from '../general/TareasTerminadas';
import { BtnRegresar, BtnDetalle, BtnGestionar, BtnDuplicar, BtnEditar, BtnForm } from '../general/BotonesAccion';
import ListarDatos from '../general/ListarDatos';
import AppBarModal from '../general/AppBarModal';
import emma_s1 from '../../global/imagenes/emma_s1.png';
import emma_w from '../../global/imagenes/emma_w.png';
import moment from 'moment';
import { consulta, generarFiltros,crear_form_data,formulario,mostrarError } from '../../global/js/funciones';
import { actualizarMensaje } from "../../redux/actions/actGlobal";
import DetalleAcompanamientoDocente from './DetalleAcompanamientoDocente';
import AcompanamientoDocenteGestionar from './AcompanamientoDocenteGestionar';

const styles = (theme) => ({
  card: {
    marginBottom: '20px'
  },
  sectionTitle: {
    color: '#B70E0C',
    marginBottom: '15px',
    fontWeight: 'bold'
  },
  listItem: {
    border: '1px solid #e0e0e0',
    marginBottom: '10px',
    borderRadius: '8px'
  },
  chipPendiente: {
    backgroundColor: '#fff3cd',
    color: '#856404'
  },
  chipCompletado: {
    backgroundColor: '#d4edda',
    color: '#155724'
  }
});

class Procesos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accionProceso: 'inicio',
      procesosFiltrados: [],
      filtrarPeriodo: false,
      filtrarTodos: false,
      periodo_filtro: '',
      estado_filtro: '',
      periodos: [],
      estados_procesos: [],
      procesos: [],
      filtros_acompanamiento: [],
      cargandoPeriodo: false,
      cargarFiltroP: true,
      cargando: true,
      administrador: false,
      modalDetalleAcompanamiento: false,
      mostrarModalDetalleAcompanamiento: false,
      modalGestionarAcompanamiento: false,
      mostrarModalGestionarAcompanamiento: false,
      proceso: null
    };
  }

  async componentDidMount() {
    this.setState({ cargando: true });
    this.esAdministrador();
    // Usar el período recibido por props o obtener el período actual
    let { periodo } = this.props;
    if (periodo) {
      this.setState({ periodo_filtro: periodo });
      this.obtenerEstadoSolicitudes(periodo);
    } else {
      // Obtener períodos y usar el período actual (último en la lista)
      let periodos = await this.obtenerPeriodos();
      if (periodos && periodos.length > 0) {
        // Usar el último período de la lista (período actual)
        let periodo_actual = periodos[periodos.length - 1].periodo;
        this.setState({
          periodo_filtro: periodo_actual,
          periodos,
          cargarFiltroP: false
        });
        this.obtenerEstadoSolicitudes(periodo_actual);
      } else {
        this.setState({ cargando: false });
      }
    }
  }

  componentDidUpdate(prevProps) {
    // Reaccionar a cambios en el período recibido por props
    if (this.props.periodo && this.props.periodo !== prevProps.periodo) {
      this.setState({ periodo_filtro: this.props.periodo, cargando: true });
      this.obtenerEstadoSolicitudes(this.props.periodo);
    }
  }

  obtenerColor = (codigo) => {
    let color = 'white';
    const colores = {
      'acom_docen_Regis': { 'backgroundColor': '#f5f5f5', 'color': '#757575' },
      'acom_docen_Pendie': { 'backgroundColor': '#967300ff', color },
      'acom_docen_Finali': { 'backgroundColor': '#009688', color },
      'Tod_Acomp': { 'backgroundColor': '#0d47a1', color }
    };
    return colores[codigo] || { 'backgroundColor': '#f5f5f5', 'color': '#757575' };
  }

  esAdministrador() {
    let { usuario } = this.props;
    console.log('usuario:', usuario);
    if (usuario && usuario.perfil && (usuario.perfil.codigo === "Per_Adm" || usuario.perfil.codigo === "Per_Acompana_Docen")) {
      this.setState({ administrador: true })
    }
  }

  cambiarEstado = (estados) => {
    this.setState(estados);
  }

  async obtenerSolicitudes(filtros = []) {
    let f = await generarFiltros(filtros);
    return new Promise(resolve => {
      consulta(`api/v1.0/acompanamiento_docente/listar/1?${f}`, null, null, (error, estado, resp) => {
        resolve(estado === 200 && !error ? resp : null);
      })
    })
  }

  async actualizarDataAcompanamiento(filtros = [{ 'llave': 'estado_actual__valorb', 'valor': 'si' }, { 'llave': 'periodo', 'valor': this.state.periodo_filtro }]) {
    this.setState({ cargando: true });
    let procesos = await this.obtenerSolicitudes(filtros);
    if (procesos) {
      this.setState({ procesos, cargando: false, filtros_acompanamiento: filtros });
    } else {
      let { actualizarMensaje } = this.props;
      actualizarMensaje({ titulo: 'Error al cargar los procesos', tipo: 'error', mostrar: true, tiempo: 4000 });
      this.setState({ cargando: false });
    }
  }

  obtenerEstadoSolicitudes = (periodo) => {
    consulta(`api/v1.0/acompanamiento_docente/estados/${periodo}`, null, null, (error, estado, resp) => {
      if (estado === 200) {
        let { general, extra } = resp;
        if (extra.length > 0) {
          extra.map(({ solicitudes, nombre, codigo, orden }) => {
            let reporte = {
              'estado_actual__codigo': codigo,
              'estado_actual__nombre': nombre,
              'num_sol': solicitudes,
              'orden': orden
            };
            general.push(reporte);
          });
        }
        this.cambiarEstado({ estados_procesos: general.sort((a, b) => a.orden - b.orden), cargando: false });
      } else {
        let { actualizarMensaje } = this.props;
        actualizarMensaje({ titulo: 'Error al cargar los estados de procesos', tipo: 'error', mostrar: true, tiempo: 4000 });
        this.setState({ cargando: false });
      }
    });
  }

  handleClick = async (codigo) => {
    if (codigo === 'Tod_Acomp') {
      // Cargar periodos y mostrar modal de filtros para "Todos los Procesos"
      let { cargarFiltroP } = this.state;
      this.setState({
        filtrarTodos: true
      });
      if (cargarFiltroP) {
        this.setState({ cargandoPeriodo: true });
        let periodos = await this.obtenerPeriodos();
        this.setState({ periodos, cargandoPeriodo: false, cargarFiltroP: false });
      }
    } else {
      this.setState({ cargando: true });
      this.setState({ accionProceso: codigo });
      this.actualizarDataAcompanamiento([{ 'llave': 'estado_actual__codigo', 'valor': codigo }, { 'llave': 'periodo', 'valor': this.state.periodo_filtro }]);
    }
  }

  pintarInicioProcesos = () => {
    const { estados_procesos } = this.state;

    return (
      <div style={{ padding: '2% 2% 0% 2%' }}>
        <Grid container direction={'row'} spacing={1} justify={'center'}>
          <Grid item xs={12} sm={12} md={12} lg={10}>
            <Grid container direction={'row'} alignItems="center" spacing={1} style={{ width: "100%" }}>
              <Grid item xs={6} sm={6} md={6} lg={6}>
                <TituloAccion principal='' alterno='Seleccione el estado a gestionar: ' />
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6}>
                <Tooltip title='Filtrar' aria-label="add" onClick={() => this.ModalfiltroPeriodo()}>
                  <IconButton edge={false} color="secondary" style={{ float: 'right' }}>
                    <FilterListIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
            <Paper elevation={0} square className="scroll contenido_fijo">
              {estados_procesos.length === 0 ? (
                <TareasTerminadas
                  mensaje='Aún no hay procesos para este periodo.'
                  marginTop='7%'
                  imagen={emma_s1}
                  widthImg="7%"
                />
              ) : (
                <Grid container direction={'row'} spacing={1} style={{ width: "100%" }}>
                  {estados_procesos.map(({ estado_actual__codigo: codigo, estado_actual__nombre: nombre, num_sol }, i) => {
                    return (
                      <Grid item xs={12} sm={12} md={6} lg={6} key={i}>
                        <Paper elevation={1} style={{ border: '1px solid #e0e0e0' }} onClick={() => this.handleClick(codigo)}>
                          <AccionesRapidas
                            imagen=''
                            titulo={`¡ ${nombre} !`}
                            sub_titulo=''
                            des_sub_titulo=''
                            avatar={this.obtenerColor(codigo)}
                            avatar_name={nombre.charAt(0).toUpperCase()}
                            list_desc={Number.isInteger(num_sol) ? [`Número de casos: ${num_sol}`] : ['Debe aplicar los filtros.']}
                          />
                        </Paper>
                      </Grid>
                    );
                  })}
                </Grid>
              )}
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  }



  pintarProcesos = () => {
    const { procesos, administrador } = this.state;
    const { usuario } = this.props;
    console.log(procesos);
    const acciones = (data) => {
      let { estado_actual: { codigo }, permiso } = data;

      const onClickDetalle = proceso => {
        this.setState({
          proceso,
          modalDetalleAcompanamiento: true,
          mostrarModalDetalleAcompanamiento: true
        });
      }
      const onClickGestionar = proceso => {
        this.setState({
          proceso,
          modalGestionarAcompanamiento: true,
          mostrarModalGestionarAcompanamiento: true
        });
      }

      if (codigo !== "acom_docen_Finali" && codigo !== "acom_docen_Pendie") {
        let detalle = <BtnDetalle callback={() => onClickDetalle(data)} color='#01579b' texto='Abrir' />;
        let gestionar = (/* permiso === '1' ||  */administrador) && <BtnGestionar callback={() => onClickGestionar(data)} color='#00bfa5' texto='Gestionar' />;
        return <div>{detalle}{gestionar}</div>;
      } else {
        let detalle = <BtnDetalle callback={() => onClickDetalle(data)} color='#01579b' texto='Abrir' />;
        /* let gestionar = (permiso === '1') && <BtnGestionar callback={() => onClickGestionar(data)} color='#00bfa5' texto='Gestionar' />; */
        return <div>{detalle}{/* {gestionar} */}</div>;
      }
    }

    return (
      <>
        <ListarDatos
          datos={procesos}
          titulo='Lista de Procesos de Acompañamiento'
          id='tbl_procesos_listar'
          opciones={true}
          descargar=''
          filtrar={false}
          refrescar={false}
          actfiltrar={() => this.actualizarDataAcompanamiento(this.state.filtros_acompanamiento)}
          actRefrescar={() => { }}
          acciones={(data) => acciones(data)}
          buscar={true}
          avatar={({ docente_solicitante: { primer_nombre } }) => primer_nombre.toUpperCase().charAt(0)}
          fila_principal={({ docente_solicitante: { primer_nombre, primer_apellido, segundo_apellido } }) => `${primer_nombre} ${primer_apellido} ${segundo_apellido}`}
          filas={[
            { 'id': 'docente', 'mostrar': ({ docente_solicitante: { primer_nombre, primer_apellido, segundo_apellido } }) => `${primer_nombre} ${primer_apellido} ${segundo_apellido}` },
            { 'id': 'identificacion', 'mostrar': ({ docente_solicitante: { identificacion } }) => identificacion },
            { 'id': 'reporte ID', 'mostrar': ({ id }) => `Reporte AC-${id}` },
            { 'id': 'asignatura', 'mostrar': ({ asignatura }) => asignatura },
            { 'id': 'programa', 'mostrar': ({ programa: { nombre } }) => nombre },
            { 'id': 'grupo', 'mostrar': ({ nombre_grupo_asignatura }) => nombre_grupo_asignatura },
            { 'id': 'fecha_registro', 'mostrar': ({ fecha_registro }) => moment(fecha_registro).format('YYYY-MM-DD, h:mm a') },
            { 'id': 'estado_actual', 'mostrar': ({ estado_actual }) => estado_actual.nombre },
          ]}
        />
      </>
    )
  }

  ModalfiltroPeriodo = async () => {
    let { cargarFiltroP } = this.state;
    this.setState({ filtrarPeriodo: true });
    if (cargarFiltroP) {
      this.setState({ cargandoPeriodo: true });
      let periodos = await this.obtenerPeriodos();
      this.setState({ periodos, cargandoPeriodo: false, cargarFiltroP: false });
    }
  }

  filtrarEstadoSolicitudes = () => {
    let { periodo_filtro } = this.state;
    let { actualizarMensaje } = this.props;

    this.setState({ filtrarPeriodo: false, cargando: true });
    actualizarMensaje({ titulo: 'Aplicando filtro de periodo...', tipo: 'info', mostrar: true, tiempo: 2000 });
    this.obtenerEstadoSolicitudes(periodo_filtro);
  }

  obtenerPeriodos = () => {
    return new Promise(resolve => {
      consulta(`api/v1.0/acompanamiento_docente/periodos`, null, null,
        (error, estado, resp) => {
          if (error || estado !== 200) {
            let { actualizarMensaje } = this.props;
            actualizarMensaje({ titulo: 'Error al cargar los periodos', tipo: 'error', mostrar: true, tiempo: 4000 });
          }
          resolve(resp)
        }
      );
    })
  }



  filtrarTodosProcesos = () => {
    const { periodo_filtro, estado_filtro } = this.state;
    let { actualizarMensaje } = this.props;

    let filtros = [{ 'llave': 'periodo', 'valor': periodo_filtro }];

    if (estado_filtro) {
      filtros.push({ 'llave': 'estado_actual__codigo', 'valor': estado_filtro });
    }

    this.setState({
      filtrarTodos: false,
      accionProceso: 'Tod_Acomp'
    });

    actualizarMensaje({ titulo: 'Aplicando filtros...', tipo: 'info', mostrar: true, tiempo: 2000 });
    this.actualizarDataAcompanamiento(filtros);
  }

  onChange = ({ target }) => {
    let { value, name } = target;
    this.setState({
      [name]: value
    });
  }

  cerrarModalDetalle = () => {
    this.setState({
      modalDetalleAcompanamiento: false,
      mostrarModalDetalleAcompanamiento: false,
      proceso: null
    });
  }

  mostrarModalGestionarAcompanamiento = (mostrar) => {
    this.setState({
      modalGestionarAcompanamiento: mostrar,
      mostrarModalGestionarAcompanamiento: mostrar
    });
  }

  gestionarAcompanamiento = async (id, data, callback) => {
      let { actualizarMensaje } = this.props;
      actualizarMensaje({ titulo: 'Enviado datos, por favor espere...', tipo: 'info', mostrar: true, tiempo: 4000 });
      let form = await crear_form_data(data);
      data.archivos.map((file, index) => form.append(`archivo${index}`, file));
      formulario(`api/v1.0/acompanamiento_docente/${id}/gestionar`, form, "post", (error, estado, resp) => {
        let titulo = 'Ha ocurrido un error, contacte con el administrador.', tipo = 'error';
        if (!error) {
          if (estado === 200) {
            tipo = 'success';
            titulo = resp.titulo;
            this.setState({ 
              modalGestionarAcompanamiento: false, 
              mostrarModalGestionarAcompanamiento: false,
              accionProceso: 'inicio',
              procesos: [],
              filtros_acompanamiento: [],
              cargando: true
            });
            setTimeout(() => {
              this.obtenerEstadoSolicitudes(this.state.periodo_filtro);
            }, 500);
          } else {
            tipo = 'info';
            titulo = resp.titulo ? resp.titulo : mostrarError(resp);
          }
        }
        actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
        callback();
      })
    }

  render() {
    const { accionProceso, filtrarPeriodo, filtrarTodos, periodo_filtro, estado_filtro, periodos, estados_procesos, cargandoPeriodo, cargando, procesos, administrador, modalDetalleAcompanamiento, mostrarModalDetalleAcompanamiento, proceso,modalGestionarAcompanamiento,mostrarModalGestionarAcompanamiento } = this.state;
    let { actualizarMensaje, usuario } = this.props;
    return (
      <>
        {!cargando ? (
          <div>
            {accionProceso === 'inicio' ? this.pintarInicioProcesos() : this.pintarProcesos()}
            {accionProceso !== 'inicio' && (
              <div className={'regresar'}>
                <BtnRegresar callback={() => this.setState({ accionProceso: 'inicio', procesosFiltrados: [] })} />
              </div>
            )}
          </div>
        ) : (
          <TareasTerminadas mensaje='Cargando...' marginTop='7%' imagen={emma_w} widthImg="7%" cargando={true} />
        )}

        <Dialog fullWidth={true} maxWidth="xs" open={filtrarPeriodo} onClose={() => this.setState({ filtrarPeriodo: false })} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <AppBarModal titulo='¡ Aplicar Filtros !' mostrarModal={() => this.setState({ filtrarPeriodo: false })} titulo_accion="" accion="" />
          <DialogContent className='scroll'>
            {!cargandoPeriodo ?
              <Grid container spacing={3} className='margin_cont'>
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className='form-control'>
                    <InputLabel htmlFor="periodo_filtro">Seleccione Periodo</InputLabel>
                    <Select
                      inputProps={{
                        name: 'periodo_filtro',
                        id: 'periodo_filtro',
                      }}
                      value={periodo_filtro}
                      onChange={this.onChange}
                      required={true}>
                      {periodos.map(({ periodo }, i) => <MenuItem key={i} value={periodo}>{periodo}</MenuItem>)}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              : <TareasTerminadas imagen={emma_w} mensaje='Cargando...' widthImg='5%' marginTop='5%' cargando={true} />
            }
          </DialogContent>
          <DialogActions>
            <BtnForm texto="CANCELAR" callback={() => this.setState({ filtrarPeriodo: false })} />
            <BtnForm texto="FILTRAR" callback={() => this.filtrarEstadoSolicitudes()} />
          </DialogActions>
        </Dialog>

        <Dialog fullWidth={true} maxWidth="sm" open={filtrarTodos} onClose={() => this.setState({ filtrarTodos: false })} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <AppBarModal titulo='¡ Filtrar Todos los Procesos !' mostrarModal={() => this.setState({ filtrarTodos: false })} titulo_accion="" accion="" />
          <DialogContent className='scroll'>
            <Grid container spacing={3} className='margin_cont'>
              <Grid item xs={12} xl={6} sm={6} md={6} lg={6}>
                <FormControl className='form-control'>
                  <InputLabel htmlFor="periodo_filtro">Seleccione Periodo</InputLabel>
                  <Select
                    inputProps={{
                      name: 'periodo_filtro',
                      id: 'periodo_filtro',
                    }}
                    value={periodo_filtro}
                    onChange={this.onChange}
                    required={true}>
                    {periodos.map(({ periodo }, i) => <MenuItem key={i} value={periodo}>{periodo}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} xl={6} sm={6} md={6} lg={6}>
                <FormControl className='form-control'>
                  <InputLabel htmlFor="estado_filtro">Seleccione Estado</InputLabel>
                  <Select
                    inputProps={{
                      name: 'estado_filtro',
                      id: 'estado_filtro',
                    }}
                    value={estado_filtro}
                    onChange={this.onChange}>
                    {estados_procesos.filter(({ estado_actual__codigo }) => estado_actual__codigo !== 'Tod_Acomp').map(({ estado_actual__codigo: codigo, estado_actual__nombre: nombre }, i) => <MenuItem key={i} value={codigo}>{nombre}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <BtnForm texto="CANCELAR" callback={() => this.setState({ filtrarTodos: false })} />
            <BtnForm texto="FILTRAR" callback={() => this.filtrarTodosProcesos()} />
          </DialogActions>
        </Dialog>
        <DetalleAcompanamientoDocente
          proceso={proceso}
          actualizarMensaje={actualizarMensaje}
          modalDetalleAcompanamiento={modalDetalleAcompanamiento}
          mostrarModalDetalleAcompanamiento={mostrarModalDetalleAcompanamiento}
          cerrarModal={this.cerrarModalDetalle}
          cargar="true"
          administrador={administrador}
          usuario={usuario}
        />
        <AcompanamientoDocenteGestionar
          usuario={usuario}
          proceso={proceso}
          actualizarMensaje={actualizarMensaje}
          modalGestionarAcompanamiento={modalGestionarAcompanamiento}
          mostrarModalGestionarAcompanamiento={this.mostrarModalGestionarAcompanamiento}
          gestionarConsultoria={this.gestionarAcompanamiento}
        />
      </>
    );
  }
}

//CARGO ESTADOS DEL MODULO
const mapStateToProps = (state) => {
  let { usuario } = state.redGlobal;
  return {
    usuario
  };
};

//CARGO FUNCIONES DEL MODULO
const mapDispatchToProps = {
  actualizarMensaje
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Procesos));